import * as Primitive from '@radix-ui/react-progress';
import React from 'react';
import { ProgressContainer, ProgressIndicator } from './Progress.styled';
import { ProgressVariants } from './Progress.types';

export type ProgressProps = Primitive.ProgressProps & {
  variant?: ProgressVariants;
};

/**
 * Makes sure the value is between 0 and max value provided (defaults to 100)
 */
const getProgressValue = (value: ProgressProps['value'], max: number) => {
  const _value = Math.min(value ?? 0, max);

  if (_value < 0) return 0;
  if (_value > max) return max;

  return _value;
};

export const Progress: React.FC<React.PropsWithChildren<ProgressProps>> = ({
  max = 100,
  value,
  variant = 'success',
  ...props
}) => {
  const _value = getProgressValue(value, max);
  const remainder = ((max - _value) / max) * 100;

  return (
    <ProgressContainer {...props} max={max} value={_value}>
      <ProgressIndicator
        data-variant={variant}
        style={{ transform: `translateX(-${remainder}%)` }}
      />
    </ProgressContainer>
  );
};
